import { useCallback, useEffect } from 'react'
import { useParams } from 'react-router'
import { Onboardings } from '@/core/enums/onboardings'
import { useOnboarding } from '@/core/hooks/use-onboarding'
import { stepsFirstPage } from '../components/steps'

export const useUsuarioEdicaoFirstPageOnboarding = (
  openOnboarding: boolean
) => {
  const { setSteps, setOpen, save, canOpen } = useOnboarding(
    Onboardings.USUARIO_EDICAO_FIRST_PAGE
  )
  const params = useParams()

  const setNextStepAndOpen = useCallback(() => {
    if (params.id || !canOpen) return
    setSteps?.([stepsFirstPage(save)[1]])
    setOpen()
  }, [params.id, canOpen, setSteps, save, setOpen])

  useEffect(() => {
    if (canOpen && openOnboarding) {
      // se o usuario estiver editando um usuario existente e não fez o onboarding ainda, carrega todos os steps
      // caso contrario carrega apenas o primeiro, o segundo será carregado dinamicamente ao selecionar opções
      if (params.id) {
        setSteps?.(stepsFirstPage(save))
      } else {
        setSteps?.([stepsFirstPage()[0]])
      }
      setOpen()
    }
  }, [canOpen, params.id, save, setOpen, setSteps, openOnboarding])

  return { setNextStepAndOpen }
}
